const nameRegExp = /[^\w\d :\-']/g;
const sanitizeName = (name = '') => typeof name === 'string' ? name.trim().replace(nameRegExp, '') : null;
export default sanitizeName;